import buildEditorIntegration from 'app/shared/translation/integrations/buildEditorIntegration';

// getSdkConnection throws when a required connection variable cannot be
// resolved (e.g. the integration is not attached to the selected pipeline and
// the variable has no default). Surface that as buildError so the Server
// Response tab can disable with a tooltip instead of crashing the drawer.
export default function buildDeliverIntegration({
  connectionJson,
  revisionMeta,
  attachment,
  starterkitId,
  integrationId,
}) {
  try {
    return {
      integration: buildEditorIntegration({
        connectionJson,
        vars: revisionMeta.vars,
        pipelineVars: attachment?.stagedRevision?.pipelineVars ?? null,
        pipelineVariables: revisionMeta.pipelineVariables,
        starterkitId,
        integrationId,
        pipelineIntegrationConsent: attachment?.pipelineIntegrationConsent ?? null,
      }),
      buildError: null,
    };
  } catch (error) {
    return { integration: null, buildError: error.message };
  }
}
